import setFolderPaneWidth from './setFolderPaneWidth';
import FolderPaneExpansionSource from 'owa-mail-store/lib/store/schema/FolderPaneExpansionSource';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isLeftRailVisible } from 'owa-left-rail';

// The width after we expand the folder panel from collapsed state.
export const EXPANDED_WIDTH: number = 228;

// The static width of the left rail, where account switcher & module switcher live.
export const LEFT_RAIL_STATIC_WIDTH = 48;

// Min width threshold for resizing in navigation. Below this number we consider the panel collapsed.
export const MIN_NAVIGATION_BAR_WIDTH = 198;

// Max width threshold for resizing in navigation. Users are not able to resize folder pane beyond this value.
export const MAX_NAVIGATION_BAR_WIDTH = 320;

/**
 * Gets the current padding left of search box.
 * @returns the number of pixels
 */
export function getSearchBoxLeftPadding(): number {
    // If left rail is visible, align to nav bar width, otherwise align to nav bar width + left rail
    const navBarWidth = getUserConfiguration().UserOptions.NavigationBarWidth;
    return !isLeftRailVisible() ? navBarWidth : navBarWidth + LEFT_RAIL_STATIC_WIDTH;
}

/**
 * Gets the current left nav width.
 * @returns the number of pixels
 */
export function getLeftNavWidth(): number {
    const folderWidth = getFolderListWidth();

    // If there is no left rail, don't account for its width
    return !isLeftRailVisible() && getMailStore().mailModule.showFolderPane
        ? folderWidth
        : folderWidth + LEFT_RAIL_STATIC_WIDTH;
}

/**
 * Gets the current folder list width. Note that this is returning the width of the
 * folder pane / list component, which is just one part of the full left nav component.
 * @returns the number of pixels
 */
export function getFolderListWidth(): number {
    let newNavigationBarWidth = getUserConfiguration().UserOptions.NavigationBarWidth;

    if (newNavigationBarWidth < MIN_NAVIGATION_BAR_WIDTH) {
        // Fallback to default navigation bar width when expanded folder pane width is smaller than threshold.
        // This is the safe-guard logic if other client has smaller MIN_NAVIGATION_BAR_WIDTH
        newNavigationBarWidth = EXPANDED_WIDTH;
    } else if (newNavigationBarWidth > MAX_NAVIGATION_BAR_WIDTH) {
        // Fallback to MAX_NAVIGATION_BAR_WIDTH if it's beyond the range
        newNavigationBarWidth = MAX_NAVIGATION_BAR_WIDTH;
    }

    // Update the UserOptions.NavigationBarWidth
    setFolderPaneWidth(newNavigationBarWidth, FolderPaneExpansionSource.Auto);

    // We need whether folder pane is expanded to be at the end, because we want to adjust UserOptions.NavigationBarWidth if it's
    // not in the range. It is used to calculate the getSearchBoxLeftPadding
    return getMailStore().mailModule.showFolderPane ? newNavigationBarWidth : 0;
}
